<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="800px"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="牌桌设备编码" prop="deviceCode">
          <el-input
            v-model.trim="form.deviceCode"
            class="fix-width"
            placeholder="请输入牌桌设备编码"
          />
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="avatar_success"
            :on-remove="avatar_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：630px * 200px</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签" prop="tagIdList">
          <el-checkbox-group v-model="form.tagIdList">
            <el-checkbox
              v-for="item of chessTagList"
              :label="item.tagId"
              :key="item.tagId"
            >
              {{ item.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="预约时段">
          <el-row class="section-el-row" v-for="(item,index) of form.sectionList" :key="index">
            <el-select v-model="item.sectionId" placeholder="请选择预约时段">
              <el-option
                v-for="item in chessSectionList"
                :key="item.sectionId"
                :label="`${item.title}(${item.basic.startTime}-${item.basic.endTime})`"
                :value="item.sectionId"
              ></el-option>
            </el-select>
            <el-input-number :min="0" class="w150" v-model="item.price" placeholder="请输入价格" />
            <el-button @click="addSection" v-if="index==0" type="primary" icon="el-icon-plus" circle></el-button>
            <el-button @click="delSection(index)" v-if="index!=0" type="danger" icon="el-icon-delete" circle></el-button>
          </el-row>
        </el-form-item>
        <el-form-item label="描述文本" prop="descList">
          <el-select
            v-model="form.descList"
            multiple
            allow-create
            filterable
            default-first-option
            placeholder="请填写描述文本(按Enter键输入下一个)"
            class="fix-width"
          ></el-select>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createRoom, updateRoom, findTagAll, findSectionAll } from '@/api/chess'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'ChessRoomEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      chessTagList: [],
      chessSectionList: [],
      form: {
        roomId: '',
        title: '',
        deviceCode:'',
        avatar: '',
        imageList: [],
        tagIdList: [],
        sectionList: [{sectionId:'',price:''}],
        descList: [],
        text: '',
        order: 1,
        step:1
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        avatar: [{ required: true, trigger: 'blur', message: '请上传封面' }],
        // deviceCode:[{ required: true, trigger: 'blur', message: '请输入deviceCode' }],
        tagIdList: [
          {
            required: true,
            trigger: 'blur',
            message: '请选择标签',
          },
        ]
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    // 获取标签
    async findTagAll() {
      const res = await findTagAll({})
      this.chessTagList = res || []
    },
    //获取所有时段
    async findSectionAll() {
      const res = await findSectionAll({})
      this.chessSectionList = res || []
    },
    addSection() {
      this.form.sectionList.push({sectionId:'',price:''})
    },
    delSection(index) {
      this.form.sectionList.splice(index,1)
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改房间'
        this.form = Object.assign(this.form, row.basic)
        this.form.roomId = row.roomId
        this.form.title = row.title
        this.form.step = row.step
      } else {
        this.title = '新增房间'
      }
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      this.findTagAll()
      this.findSectionAll()
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const roomId = this.form.roomId
          const data = Object.assign({}, this.form)
          const avalid = this.avalidateSection(data.sectionList)
          if(!avalid.pass) return this.$message.warning(avalid.msg)
          this.$baseConfirm(
            `你确定要${roomId ? '修改' : '新增'}房间吗`,
            null,
            async () => {
              roomId ? await updateRoom(data) : await createRoom(data)
              this.$baseMessage(
                `${roomId ? '修改' : '新增'}房间成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
    avalidateSection(data) {
      const sectionList = data
      const ids = []
      try {
        sectionList.forEach(item => {
          if(!item.sectionId) {
            throw('请选择预约时段')
          }
          if(!item.price) {
            throw('请设置预约时段价格')
          }
          ids.push(item.sectionId)
        });
      } catch (error) {
        return {
          pass: false,
          msg: error
        }
      }
      const idsSet = new Set(ids)
      if(ids.length > idsSet.size) {
        return {
          pass: false,
          msg: '不能存在同一预约时段'
        }
      }
      return {
        pass: true,
          msg: ''
      }
    },
    avatar_remove(file, fileList) {
      this.form.avatar = ''
    },
    avatar_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = QNHost + '/' + res.hash
    },
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    width: 167px;
    height: 167px;
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.mb-10 {
  margin-bottom: 10px;
}
.disabled .el-upload--picture-card {
  display: none;
}
.w150 {
  width: 160px;
  margin-left: 12px;
  margin-right: 12px;
}
.section-el-row {
  margin-bottom: 10px;
}
</style>
